<template>
  <section class="flex flex-col gap-4 w-full">
    <div
      class="w-full flex justify-between gap-4 bg-white p-6 my-3 rounded-md shadow-md"
    >
      <p class="font-extrabold w-[90%] text-neutral-900">
        {{ questionCount }}.{{ " " + question.prompt }}
      </p>

      <MessageVoice
        v-if="playAudio"
        :msg="msgVoice(question.prompt)"
        :scaleIcons="0.8"
        :showIconsName="false"
        @onEndMessage="onSpeak($event)"
      />
    </div>
    <div class="w-full">
      <div
        v-for="(item, i) in question?.items"
        :key="i"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion((i + 1) * 200)"
        :class="`bg-white flex items-center sm:pl-3 my-3 gap-2 rounded-md shadow-md w-full`"
      >
        <div class="flex flex-col pb-5">
          <label :for="item.id" class="cursor-pointer p-4 w-full">
            <p>
              <b>{{ String.fromCharCode(i + 65) }}.</b> {{ item.answerText }}
            </p>
          </label>
          <SelectButton
            v-model="item.selected"
            :options="options"
            optionLabel="label"
            optionValue="value"
            dataKey="value"
            aria-labelledby="custom-question-tf"
            class="custom-question-tf"
            @update:modelValue="onAnswerSelect(item)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {
  MotionEnter,
  MotionInitial,
  MotionTransition,
} from "@/models/motion.model";
import { defineComponent } from "vue";

export default defineComponent({
  name: "questionComponent",
  emits: ["onSpeak", "onAnswerSelected"],
  props: {
    question: {
      required: true,
      type: Object,
    },
    answers: {
      required: true,
      type: Object,
    },
    questionCount: {
      required: true,
      type: Number,
    },
    letter: {
      type: String,
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    question: {
      handler: function (val, oldVal) {
        this.playAudio = false;
        setTimeout(() => {
          this.playAudio = true;
        }, 200);
      },
      deep: true,
    },
  },
  data() {
    return {
      playAudio: true as boolean,
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
      value: null as boolean | null,
      options: [
      { label: this.$t('question.items.true'), value: true },
      { label: this.$t('question.items.false'), value: false },
      ],
    };
  },
  methods: {
    onAnswerSelect(item: any) {
    const trueOrFalseAnswers = this.question.items.map(qItem => qItem.selected);

    const allAnswered = trueOrFalseAnswers.every(answer => answer !== null && answer !== undefined);

    this.$emit("onAnswerSelected", {
      questionId: this.question.id,
      trueOrFalseAnswers,
      allAnswered, 
    });
  },
    msgVoice(prompt: string): string {
      let result = prompt;
      let alphabetIndex = 0;

      this.question?.items.forEach((element) => {
        const letter = String.fromCharCode(65 + alphabetIndex);
        result += ". item " + letter + "... " + element.answerText;
        alphabetIndex++;
      });
      return result;
    },
    onSpeak(event: any): void {
      this.$emit("onSpeak", event);
    },
  },
});
</script>

<style lang="scss">
.custom-question-tf {
  .p-button-label {
    font-size: 16px;
    line-height: 20.08px;
    font-weight: 500;
    color: #3e4145;
    width: 150px;
    padding: 8px 0px;
  }

  .p-button {
    border: none;
    background-color: #fafafa !important;
    padding: 6px 4px;
  }

  .p-button.p-highlight {
    background-color: #fafafa !important;
    border: none;
    padding: 6px 4px;
  }

  .p-button.p-highlight .p-button-label {
    @apply ring-2 ring-h-primary-500;
    border-radius: 4px;
    background-color: #ffffff;
  }
}

.custom-question-tf.p-selectbutton {
  max-width: fit-content;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}
</style>
